/* Split from ruckstuhl-fixes.js; function-scoped loading for performance. */
/* Ruckstuhl V8 RC19 – empfohlene Einfassung, stabile Auswahl, PORTA-Masse */
(function(){
  'use strict';

  function parseJson(value){
    if(!value)return [];
    try{
      var parsed=JSON.parse(value);
      return Array.isArray(parsed)?parsed:(parsed?[parsed]:[]);
    }catch(error){
      /* Dataset-Werte können aus einem HTML-Attribut kommen. */
      try{
        var textarea=document.createElement('textarea');
        textarea.innerHTML=value;
        var decoded=textarea.value;
        var second=JSON.parse(decoded);
        return Array.isArray(second)?second:(second?[second]:[]);
      }catch(ignore){return [];}
    }
  }

  function selectedOption(select){
    return select&&select.options&&select.selectedIndex>=0?select.options[select.selectedIndex]:null;
  }

  function recommendationItems(modal){
    var colorSelect=modal.querySelector('[id$="-color-select"]');
    var option=selectedOption(colorSelect);
    if(!option)return [];
    return parseJson(option.dataset.recommendedEdgingItems||option.dataset.recommendedEdgingColors||'');
  }

  function firstRecommendationImage(modal){
    var items=recommendationItems(modal);
    for(var index=0;index<items.length;index+=1){
      var image=String(items[index]&&items[index].image||'').trim();
      if(image)return image;
    }
    var cardImage=modal.querySelector('[data-rk-at-edging-recommendations] .rk-at-edging-recommendations__group:first-of-type .rk-at-edging-rec-card img, [data-rk-at-edging-recommendations] .rk-at-edging-rec-card img');
    return cardImage?String(cardImage.currentSrc||cardImage.src||'').trim():'';
  }

  function syncRecommendedPreview(modal){
    if(!modal||!modal.classList.contains('rk-at-modal--bahnenware'))return;
    var typeSelect=modal.querySelector('[id$="-edging"]');
    var preview=modal.querySelector('[data-rk-at-preview-edging]');
    var wrap=modal.querySelector('[data-rk-at-preview-edging-wrap]');
    if(!preview||!wrap)return;

    /* Eine echte Nutzerauswahl hat immer Vorrang. Ohne Auswahl bleibt die Vorschau leer. */
    if(typeSelect&&String(typeSelect.value||'').trim()){
      delete wrap.dataset.rkPreviewRecommended;
      delete preview.dataset.rkRecommendedOnly;
      return;
    }

    preview.hidden=true;
    wrap.hidden=true;
    delete wrap.dataset.rkPreviewRecommended;
    delete preview.dataset.rkRecommendedOnly;
  }

  function scheduleRecommendedPreview(modal,delay){
    if(!modal)return;
    window.clearTimeout(modal.__rkRecommendedTimer);
    modal.__rkRecommendedTimer=window.setTimeout(function(){
      syncRecommendedPreview(modal);
      window.setTimeout(function(){syncRecommendedPreview(modal);},120);
    },delay||20);
  }

  function stabilizeRecommendationClick(event){
    var card=event.target&&event.target.closest?event.target.closest('.rk-at-modal--bahnenware .rk-at-edging-rec-card'):null;
    if(!card)return;
    var modal=card.closest('.rk-at-modal--bahnenware');
    var scroller=modal&&modal.querySelector('.rk-at-steps');
    if(!modal||!scroller)return;
    var scrollTop=scroller.scrollTop;
    modal.classList.add('rk-at-rec-stabilizing');
    [0,40,100,220,420].forEach(function(delay){
      window.setTimeout(function(){scroller.scrollTop=scrollTop;},delay);
    });
    window.setTimeout(function(){modal.classList.remove('rk-at-rec-stabilizing');},460);
  }

  function portaMode(modal){
    var checked=modal.querySelector('.tk-config-mode:checked');
    return checked?String(checked.value||'').toLowerCase():'';
  }
  function portaShape(modal){
    var select=modal.querySelector('[id$="-shape"]');
    return select?String(select.value||'').toLowerCase():'';
  }
  function enforcePortaDiameter(modal){
    if(!modal||!modal.matches('[data-rk-at-modal][data-rk-porta-version],.rk-at-modal--porta'))return;
    var wrap=modal.querySelector('[id$="-diameter-wrap"]');
    if(!wrap)return;
    var show=portaMode(modal)!=='m2'&&portaShape(modal)==='rund';
    wrap.hidden=!show;
    if(show){
      wrap.removeAttribute('data-rk-force-hide-diameter');
      wrap.style.removeProperty('display');
    }else{
      wrap.setAttribute('data-rk-force-hide-diameter','1');
      wrap.style.setProperty('display','none','important');
    }
  }
  function schedulePorta(modal){
    if(!modal)return;
    window.clearTimeout(modal.__rkPortaDiameterTimer);
    modal.__rkPortaDiameterTimer=window.setTimeout(function(){enforcePortaDiameter(modal);},0);
    window.setTimeout(function(){enforcePortaDiameter(modal);},80);
    window.setTimeout(function(){enforcePortaDiameter(modal);},220);
  }

  function initializeOne(modal){
    if(!modal || modal.dataset.rkEdgingPortaInit==='1') return;
    modal.dataset.rkEdgingPortaInit='1';
    if(modal.classList.contains('rk-at-modal--bahnenware')) scheduleRecommendedPreview(modal,20);
    if(modal.matches('[data-rk-at-modal][data-rk-porta-version],.rk-at-modal--porta')) schedulePorta(modal);
  }

  function initialize(root){
    var scope=root||document;
    if(scope.nodeType===1 && scope.matches && scope.matches('.rk-at-modal--bahnenware,[data-rk-at-modal][data-rk-porta-version],.rk-at-modal--porta')){
      initializeOne(scope);
    }
    if(scope.querySelectorAll){
      scope.querySelectorAll('.rk-at-modal--bahnenware,[data-rk-at-modal][data-rk-porta-version],.rk-at-modal--porta').forEach(initializeOne);
    }
  }

  document.addEventListener('click',function(event){
    stabilizeRecommendationClick(event);
    var card=event.target&&event.target.closest?event.target.closest('.rk-at-modal--bahnenware .rk-at-edging-rec-card'):null;
    if(card){
      var bahnen=card.closest('.rk-at-modal--bahnenware');
      if(bahnen) scheduleRecommendedPreview(bahnen,80);
    }
  },true);

  /*
    Chrome-Stabilität RC42:
    Der frühere document-weite MutationObserver beobachtete jede class/hidden/value-
    Änderung im Konfigurator. syncRecommendedPreview() setzt selbst hidden-Attribute;
    dadurch konnte sich der Observer immer wieder selbst neu auslösen. Beim Öffnen
    einer Bahnenware-Konfiguration entstand so eine dauernde Timer-/Mutation-Kaskade,
    die den Main Thread blockierte und sogar den Schliessen-Button verzögerte.

    Die Vorschau reagiert jetzt nur noch auf die wenigen fachlich relevanten Controls.
    Mass-/m²-Eingaben lösen hier bewusst nichts mehr aus.
  */
  document.addEventListener('change',function(event){
    var target=event.target;
    if(!target || !target.closest) return;
    var modal=target.closest('.rk-at-modal--bahnenware,[data-rk-at-modal][data-rk-porta-version],.rk-at-modal--porta');
    if(!modal) return;

    if(modal.classList.contains('rk-at-modal--bahnenware') && target.matches('[id$="-color-select"],[id$="-edging"],[id$="-edging-color"]')){
      scheduleRecommendedPreview(modal,30);
    }
    if(modal.matches('[data-rk-at-modal][data-rk-porta-version],.rk-at-modal--porta') && target.matches('.tk-config-mode,[id$="-shape"]')){
      schedulePorta(modal);
    }
  },true);

  /* Dynamisch per Ajax eingefügte Konfiguratoren weiterhin erkennen – aber nur
     neue DOM-Knoten, niemals Attributänderungen innerhalb eines bestehenden Modals. */
  var observer=new MutationObserver(function(records){
    records.forEach(function(record){
      if(!record.addedNodes || !record.addedNodes.length) return;
      Array.prototype.forEach.call(record.addedNodes,function(node){
        if(node && node.nodeType===1) initialize(node);
      });
    });
  });

  function start(){
    initialize(document);
    var root=document.body||document.documentElement;
    if(root) observer.observe(root,{subtree:true,childList:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);
  else start();
})()
